import {useSelector} from 'react-redux'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {selectIsLoading} from '@vio/core/src/auth/modules/selectors'
import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import {useIsOptionalSignInEligible} from './useIsOptionalSignInEligible'

/**
 * Whether the AP login banner should render.
 *
 * @param isSurfaceVisible - whether the caller's slot renders at all, e.g. the
 * rooms list only carries the banner on mobile
 */
export const useShouldShowLoginBanner = (isSurfaceVisible = true) => {
  const isAuthLoading = useSelector(selectIsLoading)
  const isEligible = useIsOptionalSignInEligible()
  const {auth} = useBrandCapabilities()
  const toggle = useToggle()

  // The banner belongs to the optional step and its experiment. A brand that
  // gates checkout says why in SUSI, and reading the toggle here would allocate
  // its users into an experiment they can't see.
  return (
    isSurfaceVisible &&
    !isAuthLoading &&
    isEligible &&
    auth.showSignInToComplete &&
    toggle('1cmqc2sk-login-change-on-bovio-funnel', false, true)
  )
}
